interface ScrollToElementProps {
  elementId: string
  offset?: number
}

const getCoords = (elem: HTMLElement | null) => {
  if (!elem) return { top: 0, left: 0 }

  // crossbrowser version
  const box = elem.getBoundingClientRect()

  const body = document.body
  const docEl = document.documentElement

  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft

  const clientTop = docEl.clientTop || body.clientTop || 0
  const clientLeft = docEl.clientLeft || body.clientLeft || 0

  const top = box.top + scrollTop - clientTop
  const left = box.left + scrollLeft - clientLeft

  return { top: Math.round(top), left: Math.round(left) }
}

export const scrollToElement = ({
  elementId,
  offset = 0,
}: ScrollToElementProps) => {
  if (typeof window === 'undefined') return

  if (!elementId) return false

  const { top } = getCoords(document.getElementById(elementId))

  window.scrollTo({
    top: top - offset,
    behavior: 'smooth',
  })
}

// const getOffsetTop = (element: any): number => {
//   const offset = element?.offsetTop ?? 0;

//   return element?.offsetParent ? offset + getOffsetTop(element.offsetParent) : offset;
// }

export const scrollToElementCenter = (elementId: string) => {
  document.getElementById(elementId)?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}